/**
 * Returns the color associated with a given status code
 * @param {string} status - The status code ('CRTD', 'UPDT', 'REL', 'UNREL', 'DEL')
 * @returns {string} The color name associated with the status
 */
export const getStatusColor = status => {
  switch (status) {
    case 'CRTD':
      return 'blue';
    case 'UPDT':
      return 'orange';
    case 'REL':
      return 'green';
    case 'UNREL':
      return 'volcano';
    case 'DEL':
      return 'red';
    default:
      return '';
  }
};

export default {
  getStatusColor,
};
